<script>
  import router from '../../../lib/router';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import TextField from '../../../lib/components/TextField.svelte';
  import APIClient from '../../../state-charts/api-client';

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session.js';

  export let order;
  export let order_uuid;
  export let has_inited;

  let short_comment;
  let dialog;
  let complete_ratings = [
    { name: 'sad', is_active: false },
    { name: 'neutral', is_active: false },
    { name: 'happy', is_active: false },
    { name: 'extremely_happy', is_active: false },
  ];
  let wait_api = false;

  const rating_set_active = index => {
    for (let i = 0; i < complete_ratings.length; i++) {
      if (i === index) {
        complete_ratings[i].is_active = true;
      } else {
        complete_ratings[i].is_active = false;
      }
    }
  };

  const get_rating_icon = rating => {
    if (rating === 'sad') return 'sentiment_very_dissatisfied';
    if (rating === 'neutral') return 'sentiment_dissatisfied';
    if (rating === 'happy') return 'sentiment_satisfied_alt';
    if (rating === 'extremely_happy') return 'sentiment_very_satisfied';
  };

  const get_active_rating = () => {
    for (let i = 0; i < complete_ratings.length; i++) {
      if (complete_ratings[i].is_active) {
        return complete_ratings[i].name;
      }
    }
  };

  const init_update = () => {
    dialog = new MDCDialog(document.querySelector(`#update-dialog`));
  };

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  const update_feedback = async () => {
    if($session.user.last_role === 'orderer'){
      await APIClient.update_worker_feedback(
        {
          comment: short_comment,
          order_uuid: order_uuid,
          rating: get_active_rating(),
        },
        () => {
          location.reload();
        }
      );
    } else{
      await APIClient.update_orderer_feedback(
        {
          comment: short_comment,
          order_uuid: order_uuid,
          rating: get_active_rating(),
        },
        () => {
          location.reload();
        }
      );
    }

  };

  onMount(() => { init_update() });
</script>

<div id="update-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {t9n(TS.ORDER_ADD_FBACK)}
      </h2>

      <div
        class="mdc-dialog__content"
        id="my-dialog-content"
        style="z-index: 9999">

        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>
            {#if $session.user.last_role === 'orderer'}
              {t9n(TS.ORDER_RATE_WORKER)}
              {:else}
              {t9n(TS.ORDER_RATE_ORDERER)}
              {/if}

          </h4>
          <p>{t9n(TS.ORDER_FEEDBACK_TEXT)}</p>
        </div>

        <div style="padding-left: 20px; padding-right: 20px;">
          <h4>{t9n(TS.ORDER_CHOOSE_RAT)}</h4>
        </div>

        {#each complete_ratings as rating, i}
          <a href="javascript:;" on:click={() => rating_set_active(i)}>
            <i
              class="material-icons"
              class:ratings={i === 0}
              class:active-icon={rating.is_active}>
              {get_rating_icon(rating.name)}
            </i>
          </a>
        {/each}

        <div style="margin-top: 15px; margin-left: 20px;">
          <TextField
            bind:value={short_comment}
            id="field-update"
            label={t9n(TS.ORDER_SHORT_COMMENT)}
            max_chars={20000}
            disable_resize={false}
            show_counter={false}
            width="1000px" />
        </div>
      </div>

      <footer class="mdc-dialog__actions">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->

        <button
          on:click={() => close()}
          class="mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.CHANGE_PASSWORD_CANCEL_LABEL)}
        </button>

        <button
          on:click={async () => { await update_feedback() }}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDER_SUBMIT)}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
    .mdc-dialog__content {
        font-family: Roboto, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: 400;
        letter-spacing: 0.03125em;
        text-decoration: inherit;
        text-transform: inherit;
        flex-grow: 1;
        box-sizing: border-box;
        margin: 0;
        padding: 20px 24px;
        padding-top: 20px;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    .mdc-dialog__title {
        font-family: Roboto, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 1.25rem;
        line-height: 2rem;
        font-weight: 500;
        letter-spacing: 0.0125em;
        text-decoration: inherit;
        text-transform: inherit;
        display: block;
        position: relative;
        flex-shrink: 0;
        box-sizing: border-box;
        margin: 0;
        padding: 0 24px 9px;
        border-bottom: 1px solid transparent;
    }

    .mdc-dialog__actions {
        display: flex;
        position: relative;
        flex-shrink: 0;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        box-sizing: border-box;
        min-height: 52px;
        margin: 0;
        padding: 8px;
        border-top: 1px solid transparent;
    }

    #update-dialog .mdc-dialog__surface {
        max-width: 500px;
        width: 500px;
    }

    #update-dialog .material-icons {
        font-size: 50pt;
        color: var(--orderer-background-color);
        opacity: 50%;
    }

    #update-dialog .material-icons:hover {
        opacity: 70%;
    }

    #update-dialog .active-icon {
        opacity: 100%;
        animation: transition_in 0.3s;
    }

    .btn-close {
        margin-left: 5px;
    }

    tr {
        text-align: left;
    }

    .ratings {
        margin-left: 90px;
    }
</style>
